import { AlertDialogProvider } from '@fukuri-admins/ui/common/AlertDialog';
import { NotFound } from '@fukuri-admins/ui/common/errors';
import { ToastProvider } from '@fukuri-admins/ui/common/Toast/provider';
import { TooltipProvider } from '@fukuri-admins/ui/common/Tooltip/provider';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { InvitationClient } from '~/pages/Client/Invitation';
import { AuthProvider } from './components/auth/AuthProvider';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { PublicRoute } from './components/auth/PublicRoute';
import { LegacyDashboardLayout, MainContentLayout } from './layouts';
import { EditClient } from './pages/Client/Edit';
import { EditClientAdminUser } from './pages/ClientAdminUser/Edit';
import { IndexClientAdminUser } from './pages/ClientAdminUser/Index';
import { ShowClientAdminUser } from './pages/ClientAdminUser/Show';
import { ClientContractListIndex } from './pages/client-contracts';
import { CreateClientContractTermFormIndex } from './pages/client-contracts/new';
import { ClientContractTermDetailIndex } from './pages/clients/[clientId]/client-contracts/[termId]';
import { ClientContractTermEditIndex } from './pages/clients/[clientId]/client-contracts/[termId]/edit';
import { ClientsShow } from './pages/clients/[id]';
import { ClientsIndex } from './pages/clients/index';
import { ClientsNew } from './pages/clients/new';
import { ContractPlanListIndex } from './pages/contract-plans';
import { ContractPlanDetailIndex } from './pages/contract-plans/[planId]';
import { GroupsEdit } from './pages/groups/edit';
import { GroupsIndex } from './pages/groups/index';
import { GroupsNew } from './pages/groups/new';
import { GroupsShow } from './pages/groups/show';
import { Login } from './pages/Login';
import { CreatePushNotification } from './pages/PushNotification/Create';
import { IndexPushNotification } from './pages/PushNotification/Index';
import { IndexService } from './pages/Service/Index';
import { ShowService } from './pages/Service/Show';
import { IndexServiceUsage } from './pages/ServiceUsage/Index';
import { TopBannersIndex } from './pages/top-banners';
import { TopBannersEdit } from './pages/top-banners/[id]/edit';
import { TopBannersNew } from './pages/top-banners/new';
import { IndexUserDailyFirstAccessLog } from './pages/UserDailyFirstAccessLog/Index';
import { UsersShow } from './pages/users/[userId]';
import { UsersEdit } from './pages/users/[userId]/edit';
import { UsersActivationsDownload } from './pages/users/activations/download';
import { UsersActivationsNew } from './pages/users/activations/new';
import { UsersIndex } from './pages/users/index';
import { UsersNew } from './pages/users/new';

function App() {
  return (
    <ToastProvider>
      <TooltipProvider>
        <AlertDialogProvider>
          <BrowserRouter>
            <AuthProvider>
              <Routes>
                <Route element={<PublicRoute />}>
                  <Route path='/login' element={<Login />} />
                </Route>
                <Route element={<ProtectedRoute />}>
                  <Route element={<LegacyDashboardLayout />}>
                    <Route path='/client-admins' element={<IndexClientAdminUser />} />
                    <Route
                      path='/client-admins/:client_admin_id'
                      element={<ShowClientAdminUser />}
                    />
                    <Route
                      path='/client-admins/:client_admin_id/edit'
                      element={<EditClientAdminUser />}
                    />

                    <Route path='/services' element={<IndexService />} />
                    <Route path='/services/:service_id' element={<ShowService />} />
                    <Route path='/service-report' element={<IndexServiceUsage />} />
                    <Route path='/login-report' element={<IndexUserDailyFirstAccessLog />} />
                    <Route path='/push-notifications' element={<IndexPushNotification />} />
                    <Route path='/push-notifications/create' element={<CreatePushNotification />} />
                  </Route>
                  <Route element={<MainContentLayout />}>
                    <Route path='/clients' element={<ClientsIndex />} />
                    <Route path='/clients/new' element={<ClientsNew />} />
                    <Route path='/clients/:id' element={<ClientsShow />} />
                    <Route path='/clients/:client_id/edit' element={<EditClient />} />
                    <Route path='/groups' element={<GroupsIndex />} />
                    <Route path='/groups/new' element={<GroupsNew />} />
                    <Route path='/groups/:id' element={<GroupsShow />} />
                    <Route path='/groups/:id/edit' element={<GroupsEdit />} />
                    <Route path='/top-banners' element={<TopBannersIndex />} />
                    <Route path='/top-banners/new' element={<TopBannersNew />} />
                    <Route path='/top-banners/:id/edit' element={<TopBannersEdit />} />
                    <Route path='/users/activations/new' element={<UsersActivationsNew />} />
                    <Route
                      path='/users/activations/download'
                      element={<UsersActivationsDownload />}
                    />
                    <Route path='/users' element={<UsersIndex />} />
                    <Route path='/users/new' element={<UsersNew />} />
                    <Route path='/users/:user_id' element={<UsersShow />} />
                    <Route path='/users/:user_id/edit' element={<UsersEdit />} />
                    <Route path='/contract-plans' element={<ContractPlanListIndex />} />
                    <Route path='/contract-plans/:planId' element={<ContractPlanDetailIndex />} />
                    <Route path='/client-contracts' element={<ClientContractListIndex />} />
                    <Route
                      path='/client-contracts/new'
                      element={<CreateClientContractTermFormIndex />}
                    />
                    <Route
                      path='/clients/:clientId/client-contracts/:termId'
                      element={<ClientContractTermDetailIndex />}
                    />
                    <Route
                      path='/clients/:clientId/client-contracts/:termId/edit'
                      element={<ClientContractTermEditIndex />}
                    />
                  </Route>
                  <Route path='/clients/:client_id/invitation' element={<InvitationClient />} />
                </Route>

                <Route path='/' element={<Navigate to='/login' replace />} />
                <Route path='*' element={<NotFound />} />
              </Routes>
            </AuthProvider>
          </BrowserRouter>
        </AlertDialogProvider>
      </TooltipProvider>
    </ToastProvider>
  );
}

export default App;
